/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useCallback, useMemo } from 'react';
import { DROPDOWN_ITEM } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/action-subject-type.tsx';
import { CUSTOM_ITEM_DROPDOWN_ACTION } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';
import { LEVEL_FOUR } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type {
	UseAnalyticsL4,
	ViewParams,
} from '@jira/navigation-apps__sidebar-nav4-sidebars-common-jpd-nav-views/src/controllers/analytics/types.tsx';
import type { NavigationCollection } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-jpd-nav-views/src/common/types.tsx';
import type { ItemId } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-jpd-nav-views/src/common/constants/analytics/item-id.tsx';

export const useRoadmapsAnalyticsL4: UseAnalyticsL4<NavigationCollection> = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const commonAttributes = useMemo(
		() => ({
			level: LEVEL_FOUR,
		}),
		[],
	);

	// actions inside meatball menu on views
	const sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent = useCallback(
		({
			itemId,
			container,
			viewParams,
		}: {
			itemId: ItemId;
			container: NavigationCollection;
			viewParams: ViewParams;
		}) => {
			const { collectionUUID } = container;

			const event = createAnalyticsEvent({
				action: 'clicked',
				actionSubject: DROPDOWN_ITEM,
			});

			const attributes = {
				...commonAttributes,
				componentType: CUSTOM_ITEM_DROPDOWN_ACTION,
				itemId,
				parentItemId: viewParams.viewId,
				parentItemType: viewParams.viewKind,
				collectionUUID,
			};
			fireUIAnalytics(event, 'roadmapsNavigationMenuItem', attributes);
		},
		[commonAttributes, createAnalyticsEvent],
	);

	return {
		sendMeatBallDropDownOnViewsMenuItemAnalyticsEvent,
	};
};
